<template>
  <div :class="{'min-height': isEditMode}" class="automated-content-list">
    <div v-for="region in regions" :key="region.displayName" class="region">
      <heading
        class="region-title"
        :tagField="headingSize"
        :text-field="displayNameField(region)" />
      <div class="tiles">
        <AutomatedContentListTile
          v-for="venue in region.venues"
          :key="venue.id"
          :fields="venue.fields"
          :innerHeadingSize="tileHeadingSize" />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import get from '~/helpers/get'
import { decreaseTagValue } from '~/helpers/decrease-tag-value'
import AutomatedContentListTile from '~/components/sitecore/automated-content-list-tile'
import Heading from '~/components/sitecore/heading'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
export default {
  name: 'AutomatedContentList',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  },
  components: {
    AutomatedContentListTile,
    Heading
  },
  computed: {
    ...mapJssGetters(['isEditMode']),
    regions () {
      return get(this.fields, 'regions')
    },
    headingSize () {
      return get(this.fields, 'headingSize', { value: 'H2' })
    },
    tileHeadingSize () {
      return decreaseTagValue(this.headingSize)
    }
  },
  methods: {
    displayNameField (region) {
      return {
        value: region.displayName
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.automated-content-list {
  margin: $space-090 $space-050;

  &.min-height {
    min-height: 200px;
  }
  @include tablet {
    margin: $space-100 $space-060;
  }

  .region-title {
    @include font('070');
    margin-bottom: $space-070;

    @include tablet {
      @include font('090');
    }
  }
}
.tiles {
  margin: 0 -$space-020;
  display: flex;
  overflow: scroll;
  @include tablet {
    overflow: initial;
    flex-wrap: wrap;
    margin-bottom: -$space-090;
  }
}
.region:not(:last-of-type) {
  margin-bottom: $space-090;
  @include tablet {
    margin-bottom: $space-100;
  }
}
</style>
